import { lazy } from 'react'

export const ShowMTInfoModalAsync = lazy(() => import('./ShowMTInfo')
    .then((module) => ({ default: module.ShowMTInfo }))
)
